import { Component, OnInit } from '@angular/core';
import { UserNotificationService } from '@services/user-notification.service';

@Component({
  selector: 'app-notification-indicator',
  templateUrl: './notification-indicator.component.html',
  styleUrls: ['./notification-indicator.component.css'],
})
export class NotificationIndicatorComponent implements OnInit {
  public notificationCount: number;
  public constructor(private userNotificationService: UserNotificationService) {}

  async ngOnInit() {
    this.userNotificationService.unreadCountChanged.subscribe((x) => {
      this.notificationCount = x;
    });

    this.userNotificationService.initialize();
  }
}
